import {TranslateService} from '@brunata-angular/util';
import {VariableAlarmTypeEligibility} from './variable-alarm-type-eligibility.model';

export function getTemplates(
    translateService: TranslateService,
    variableAlarmEligibility?: VariableAlarmTypeEligibility,
): Array<{
    type: string;
    translation: {
        header: string;
        description: string;
    };
    variableAlarmEligibility: boolean;
}> {
    return [
        {
            type: 'runningToilet',
            translation: {
                header: translateService.translate('variable-alarms_header_RT'),
                description: translateService.translate('variable-alarms_RT'),
            },
            variableAlarmEligibility:
                variableAlarmEligibility != null ? variableAlarmEligibility.runningToilet : true,
        },
        {
            type: 'indoorClimateHumidityHigh',
            translation: {
                header: translateService.translate('variable-alarms_header_R_High'),
                description: translateService.translate('variable-alarms_R_High'),
            },
            variableAlarmEligibility:
                variableAlarmEligibility != null
                    ? variableAlarmEligibility.indoorClimateHumidityHigh
                    : true,
        },
        {
            type: 'indoorClimateHumidityLow',
            translation: {
                header: translateService.translate('variable-alarms_header_R_Low'),
                description: translateService.translate('variable-alarms_R_Low'),
            },
            variableAlarmEligibility:
                variableAlarmEligibility != null
                    ? variableAlarmEligibility.indoorClimateHumidityLow
                    : true,
        },
        {
            type: 'indoorClimateHumidityLeakage',
            translation: {
                header: translateService.translate('variable-alarms_header_R_Leakage'),
                description: translateService.translate('variable-alarms_R_Leakage'),
            },
            variableAlarmEligibility:
                variableAlarmEligibility != null
                    ? variableAlarmEligibility.indoorClimateHumidityLeakage
                    : true,
        },
        {
            type: 'indoorClimateTemperatureHigh',
            translation: {
                header: translateService.translate('variable-alarms_header_C_High'),
                description: translateService.translate('variable-alarms_C_High'),
            },
            variableAlarmEligibility:
                variableAlarmEligibility != null
                    ? variableAlarmEligibility.indoorClimateTemperatureHigh
                    : true,
        },
        {
            type: 'indoorClimateTemperatureLow',
            translation: {
                header: translateService.translate('variable-alarms_header_C_Low'),
                description: translateService.translate('variable-alarms_C_Low'),
            },
            variableAlarmEligibility:
                variableAlarmEligibility != null
                    ? variableAlarmEligibility.indoorClimateTemperatureLow
                    : true,
        },
        {
            type: 'indoorClimateCo2High',
            translation: {
                header: translateService.translate('variable-alarms_header_Co2_High'),
                description: translateService.translate(
                    'mappers_Indoor-Climate-CO2_High',
                    'online',
                    'common',
                ),
            },
            variableAlarmEligibility:
                variableAlarmEligibility != null
                    ? variableAlarmEligibility.indoorClimateCo2High
                    : true,
        },
        {
            type: 'customAlarm',
            translation: {
                header: translateService.translate('variable-alarms_Custom-alarm'),
                description: translateService.translate('variable-alarms_customAlarm'),
            },
            variableAlarmEligibility:
                variableAlarmEligibility != null ? variableAlarmEligibility.customizedAlarm : true,
        },
    ].filter(template => template.variableAlarmEligibility);
}
